import { useResizeObserver } from "@amzn/stencil-react-components/hooks";
import { Col, View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { SearchResult } from "@/pages/hardware-search/components/SearchResult/search-result";
import React, { FC, useLayoutEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

interface SearchResultItem {
  taxonomyId: string;
  name: string;
  logoUrl?: string;
  shortDescription?: string;
  price?: { amount?: number; currency?: string };
  etaDays?: number;
}

export interface CatalogItemsListProps {
  scrollableTarget: string;
  items: SearchResultItem[];
  isLoading: boolean;
  isLoadingNextItems: boolean;
  totalCount: number;
  shouldLoadMore: () => boolean;
  onSearchNext: () => void;
}

const SearchItemsList: FC<CatalogItemsListProps> = (props) => {
  const { ref, height } = useResizeObserver<HTMLDivElement>();
  const { items, isLoading, isLoadingNextItems, onSearchNext, scrollableTarget, 
    totalCount } = props;

  const hasMoreItems = () => {
    return items?.length < totalCount!;
  };

  useLayoutEffect(() => {
    if (!hasMoreItems()) {
      return;
    }

    if (props.shouldLoadMore()) {
      props.onSearchNext();
    }
  }, [height, isLoadingNextItems, isLoading]);

  const itemsComponents = items!.map((item) => (
    <SearchResult
      key={item.taxonomyId}
      taxonomyId={item.taxonomyId}
      logoUrl={item.logoUrl || ""}
      name={item.name}
      shortDescription={item.shortDescription || ""}
      available=""
      price={item.price}
      etaDays={item.etaDays}
    />
  ));

  return (
    <Col data-testid="search-results-list" ref={ref}>
      <InfiniteScroll
        dataLength={itemsComponents.length}
        next={onSearchNext}
        hasMore={hasMoreItems()}
        loader={
          <View padding="S700">
            <Spinner size={SpinnerSize.Medium} />
          </View>
        }
        scrollableTarget={scrollableTarget}
      >
        {itemsComponents}
      </InfiniteScroll>
    </Col>
  );
};

export default SearchItemsList;
